import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MultiLineAction } from './models/multi-line-action.model';
import { MultiLineItem } from './models/multi-line-item.model';

@Component({
  templateUrl: './multi-line-cell-renderer.component.html',
  styleUrls: ['./multi-line-cell-renderer.component.scss'],
  standalone: false,
})
export class MultiLineCellRendererComponent
  implements ICellRendererAngularComp
{
  items: MultiLineItem[] = [];
  action?: MultiLineAction;

  showAll = false;
  maxVisible = 5;
  contentClasses = '';
  params!: ICellRendererParams;

  get visibleItems(): MultiLineItem[] {
    return this.showAll ? this.items : this.items.slice(0, this.maxVisible);
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    const value = params.value ?? [];
    this.maxVisible = (params as any).maxVisible ?? 5;
    this.contentClasses = (params as any).contentClasses ?? '';
    this.action = (params as any).action;

    if (Array.isArray(value)) {
      this.items = value.map((v) => (typeof v === 'string' ? { text: v } : v));
    } else if (value != null && value !== '') {
      this.items = [{ text: String(value) }];
    } else {
      this.items = [];
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  clickAction(item: MultiLineItem, event: MouseEvent): void {
    event.stopPropagation();
    this.action?.onClick({
      item,
      params: this.params,
      rowData: this.params.data,
    });
  }

  toggleShowAll(event: MouseEvent): void {
    event.stopPropagation();
    this.showAll = !this.showAll;
  }

  trackByIndex(i: number): number {
    return i;
  }

  isItemDisabled(item: MultiLineItem): boolean {
    return this.action?.isDisabled?.(item, this.params) ?? false;
  }

  getButtonClass(item: MultiLineItem): string {
    return this.isItemDisabled(item)
      ? 'btn-outline-secondary'
      : (this.action?.btnClass ?? 'btn-outline-secondary');
  }

  getTextClass(item: MultiLineItem): string {
    return this.isItemDisabled(item) ? 'text-secondary' : this.contentClasses;
  }
}
